import TableCell from '@material-ui/core/TableCell';

export default TableCell;
